import axios from "axios";
import Cookies from "js-cookie";

import { logoutChannel } from "../common/logoutChannel";


const app = axios.create({
	headers: {
		'Access-Control-Allow-Origin': '*',
		'Content-Type': 'application/json',
	},
	withCredentials: true
})

const handleLogout = async () => {
	logoutChannel.postMessage("Logout")

	Cookies.remove('jwtTokenClient')
	
	window.location.reload()
	//await removeSession()
}

export const handleApiError = (error) => {
	if (axios.isAxiosError(error)) {
		console.log("error response", error)
		if (error.response) {
			// The request was made and the server responded with a status code
			error.response.failure = true

			if(error.response?.data?.errorCode === "SESSION_NOT_FOUND"){
				console.log("SESSION_NOT_FOUND")
				handleLogout()
			}

			return error.response
		} else if (error.request) {
			// The request was made but no response was received
			return {
				data: {
					error: error.message,
					errorCode: 500
				},
				failure: true
			}
		} else {
			// Something happened while setting up the request
			return {
				data: {
					error: error.message,
					errorCode: 500
				},
				failure: true
			}
		}
	} else {
		console.log('Custom Error:', error.message); // Custom backend error or other non-Axios error
		return error
	}
};

export default app;